import angular from "angular";

export const angularJsApp: ng.IModule = angular.module('mapes', [
  "ngRoute",
  "ngAnimate",
  "ngOnload",
  "ui.bootstrap",
  "ui.multiselect",
  "isteven-multi-select",
])
.constant('_', window._)
.run(function ($rootScope: { _: any; }) {
  $rootScope._ = window._;
})
.config(['$locationProvider', function ($locationProvider: { hashPrefix: (arg0: string) => void; }) {
  $locationProvider.hashPrefix('');
}]);

